import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  BaseHierarchicalCrudComponent,
  CrudPage,
  GenericForm,
} from '@zendra/shared';
import {
  PropertyOriginDestinationCreateDto,
  PropertyOriginDestinationDto,
  PropertyOriginDestinationExcelDownloadDto,
  PropertyOriginDestinationUpdateDto,
} from '../proxy/geographic/dtos/property-origin-destination';
import { PropertyOriginDestinationService } from '../proxy/geographic/controllers';
import {
  PROPERTYORIGINDESTINATION_CONFIG,
  PROPERTYORIGINDESTINATION_FIELDS,
} from './property-origin-destination.config';

@Component({
  selector: 'app-property-origin-destination',
  imports: [CardComponent, CardBodyComponent, CrudPage, GenericForm],
  providers: [ListService, PropertyOriginDestinationService, ConfirmationService],
  templateUrl: './property-origin-destination.html',
  styleUrl: './property-origin-destination.scss',
})
export class PropertyOriginDestination extends BaseHierarchicalCrudComponent<
  PropertyOriginDestinationDto,
  PropertyOriginDestinationCreateDto,
  PropertyOriginDestinationUpdateDto,
  PropertyOriginDestinationExcelDownloadDto
> {
  service = inject(PropertyOriginDestinationService);
  config = PROPERTYORIGINDESTINATION_CONFIG;
  fields = PROPERTYORIGINDESTINATION_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: PropertyOriginDestinationDto,
  ): PropertyOriginDestinationUpdateDto {
    return {
      originLocationId: data.originLocationId,
      destinationLocationId: data.destinationLocationId,
      propertyLocationId: data.propertyLocationId,
      distance: data.distance,
      unPavedRoadDistance: data.unPavedRoadDistance,
      pavedRoadDistance: data.pavedRoadDistance,
      tollCount: data.tollCount,
      isTruckAllowed: data.isTruckAllowed,
      isBitrenAllowed: data.isBitrenAllowed,
      isCurrent: data.isCurrent,
      isFuture: data.isFuture,
      executionDate: data.executionDate,
      isActive: data.isActive,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PropertyOriginDestination';
  }
}